module.exports = {
  // 西班牙语
  language: "Español",

  //确认支付按钮
  components_confirmPay_btn: {
    notYet: "Todavía no",
    waitingTips: "Esperando tu pago ",
  },

  //菜单
  menu: {
    home: "Inicio",
    menu: "Menú",
    transactions: "Transacciones",
    language: "Idioma",
    privacy: "Política de privacidad",
    logOut: "Cierre de sesión",
    service: "Condiciones de servicio",
    RouterMenu_experience:
      "Iniciar sesión para desbloquear la experiencia completa",
    login_Youlogged: "Ya ha iniciado sesión",
    RouterMenu_Welcome: "¡Bienvenido a Alchemy Pay!",
    RouterMenu_history: "No hay historial todavía",
    loginOut_Dismiss: "Cancelar",
    loginOut_title: "¿Seguro que quiere cerrar la sesión?",
  },

  //导航文案
  navTabTitle: {
    Completepayment: "Completa el pago",
  },

  //按钮组件
  button_components: {
    proceed: "Proceder",
  },

  //---------------------------- 支付方式信息组件 ----------------------------
  PayMethodInfo_components: {
    title: "Resumen del pedido",
    title2: "Su método de pago elegido es",
  },
  //---------------------------- 扫码QR Code组件 ----------------------------
  QrCode_components: {
    title1: "Pagar",
    title2: "para completar tu compra.",
    title3:
      "Abra su aplicación de pago y escanee el código QR a continuación para completar el pago.",
    copy: "COPIAR",
  },
  //---------------------------- 钱包地址和网络信息组件 ----------------------------
  WalletAddress_components: {
    title1: "Su",
    title2: "cartera",
  },
  //---------------------------- 表单信息 ----------------------------
  formInfo: {
    //新增
    fullName_placeholder: "Ingrese el nombre completo",
    phone_title: "Por favor, introduzca su número de teléfono",
    id_title: "Ingrese el número de identificación",
    id_placeholder1: "Introducir el",
    id_placeholder2: "número de identificación de dígitos",
    bankAccount_placeholder: "Elija su tipo de cuenta",
    accountNumber_placeholder:
      "Ingrese el número de identificación de 22 dígitos",
    bankCode_placeholder: "Ingrese el número de identificación de 3 dígitos",
    //vnd 选择bank code
    vnd_bankCode_placeholder: "Elige el código del banco",
    select_id_placeholder: "Elija su tipo de identificación",
  },

  vndChildren: {
    amount: "Cantidad",
    oneTitle:
      " Vaya a la aplicación bancaria, escanee el código QR o ingrese la identificación del destinatario manualmente",
    twoTitle:
      " Complete el contenido de la transferencia en el cuadro de mensaje",
    threeTitle: " hacer una transferencia de dinero",
    Accountname: "Nombre para mostrar de la cuenta",
    AccountID: "ID de la cuenta",
    Transfercontent: "Transferir contenido",
  },

  //菲律宾页面
  phpPayment: {
    PaymentGuide: "Guía de pago",
    BillNumber: "Número de envío digital",
    PAYSO1:
      'Ingrese a la billetera Gcash, haga clic en "Facturas" y seleccione pago de facturas',
    PAYSO2: 'Busca y selecciona "PAYSO"',
    PAYSO3: "complete esta información y haga clic en [SIGUIENTE]",
    Incorrect:
      "Por favor, asegúrese de que la cantidad que nos transfirió es precisa y correcta. La información o cantidad incorrecta causará el fracaso del pedido o la pérdida de fondos.",
  },

  //买币阿根廷支付
  ArgentinaPay: {
    BankName: "Nombre del banco",
    ChooseBank: "Elige tu Banco",
    selectcard: "Seleccione un banco",
    BankAccount: "Cuenta bancaria",
    cardnumber: "Por favor ingrese el número de tarjeta correcto",
    Bankcode: "codigo bancario",
    correctcode: "Por favor ingrese el código correcto",
    ID: "ID",
    SelectBank: "Seleccionar banco",
    phone: "número de teléfono",
    phoneTips: "Numero de telefono invalido",
    paymentResultError:
      "La información de la cuenta bancaria es incorrecta. Por favor, compruebe y compre de nuevo.",
    Choose: "Elija su tipo de cuenta",
    chequing: "cheques",
    Saving: "ahorros",
    Amount: "Monto:",
    AccountNumber: "Número de cuenta",
    BankCode: "Codigo bancario",
    fullNameTips: "Nombre completo inválido",
    idTips: "Número de identificación no válido",
  },

  // TRY银行转账表单信息
  TRY_form: {
    // TRY银行转账
    nationality_title: "Introduce la nacionalidad",
    authCardNo_title: "Ingrese el número de identificación",
    firstName_title: "Ingrese el nombre",
    lastName_title: "Ingrese el Apellido",
    address_title: "Ingrese la dirección",
    birthday_title: "Introduzca el cumpleaños",
    authCardNo_tips: "Número de identificación de celda no válido",
    firstName_Tips: "Celda inválida Nombre",
    lastName_tips: "Celda inválida Apellido",
    address_tips: "Dirección de celda no válida",
    birthday_tips: "Celda inválida Cumpleaños",
    address_Placeholder:
      "Lo mismo con la dirección en su tarjeta de identificación",
    ID_CARD: "Tarjeta de identificación",
    DRIVER_LICENSE: "Licencia de conducir",
    PASSPORT: "Pasaporte",
  },

  // KRW银行转账表单信息
  KRW_form: {
    // TRY银行转账
    nationality_title: "Introduce la nacionalidad",
    authCardNo_title: "Ingrese el número de identificación",
    firstName_title: "Ingrese el nombre",
    lastName_title: "Ingrese el Apellido",
    address_title: "Ingrese la dirección",
    birthday_title: "Introduzca el cumpleaños (día/mes/año)",
    authCardNo_tips: "Número de identificación de celda no válido",
    firstName_Tips: "Celda inválida Nombre",
    lastName_tips: "Celda inválida Apellido",
    address_tips: "Dirección de celda no válida",
    birthday_tips: "Celda inválida Cumpleaños",
    address_Placeholder:
      "Lo mismo con la dirección en su tarjeta de identificación",
    RESIDENT_REGISTRATION_NUMBER: "Tarjeta de identificación",
    DRIVER_LICENSE: "Licencia de conducir",
    PASSPORT: "PASSPORT_NUMBER",
    ALIEN_REGISTRATION_NUMBER: "Permiso de residencia",
    DOMESTIC_RESIDENCE_REPORT_NUMBER: "Certificado de registro de dirección",
  },

  //---------------------------- 银行转账收银台 ----------------------------
  cashierDesk_bankTransfer: {
    tiemOut: "El pedido será cancelado en {0} {1}",
    PleasePay: "Por favor pague",
    title1: "Abre tu solicitud bancaria. Introduce este número de referencia",
    title2: "Ingrese la información de registro de la cuenta",
    CLABEinterbancaria: "CLABE interbancaria:",
    Destinationbank: "Banco de destino:",
    Beneficiary: "Beneficiario:",
    Payamount: "Cantidad de pago:",
    title3:
      "Si su pago no se completa durante mucho tiempo, le sugerimos que cargue los documentos de pago a nuestro servicio de atención al cliente. Esto acelerará nuestra confirmación de su pago.",
  },

  //---------------------------- 用户支付信息组件 ----------------------------
  TraderInformation: {
    title: "Información del comerciante",
  },

  //选择支付方式页
  buyPayWay: {
    BINANCEPAY: "BINANCE PAY",
    qrCode: "QR Code",
    Philippines: "Transferencias bancarias",
    Khipu: "Transferencias bancarias",
    ThaiQR: "ThaiQR",
    pix: "PIX",
    recentlyUsed: "Método de pago guardado",
    paymentMethod: "Añadir un nuevo método de pago",
    rampFee: "Cuota de procesamiento",
    card: "Tarjeta",
    card1: "Tarjeta",
    creditCard: "Tarjeta de crédito",
    bankTransfer: "Pago inmediato",
    bancoTransfer: "Transferencia Bancaria",
    opm: "OPM",
    virtualAccount: "Transferencias bancarias",
    eWallet: "Billetera electrónica",
    binancePay: "BINANCE PAY",
    applePay: "Apple Pay",
    googlePay: "Google Pay",
    promptPay: "Pronto Pago",
    addCardTitle: "Añadir nueva tarjeta",
    useCardTitle: "Uso de la nueva tarjeta",
    edit: "Editar",
    cancel: "Cancelar",
    support: "Soporte",
    cardLimitTips: "Límite de 6 tarjetas alcanzado",
    kaKaoPay: "KaKao Pay",
    GCash: "Transferencias bancarias",
    touchNGo: "Touch n go",
    payNow: "Pagar ahora",
    proceed: "Proceder",
    Unavaible: "Indisponible",
    limit: "Límite",
    deleteTips: "Eliminado con éxito",
  },

  //买币信用卡表单组件
  components_buyForm: {
    formTitle: "Introduzca los datos de su tarjeta",
    firstName: "Nombre",
    lastName: "Apellido",
    nameTips: "¡Nombre inválido!",
    cardNumber: "Número de tarjeta",
    cardNumTips: "Por favor, introduzca un número de tarjeta válido",
    expirationDate: "Fecha de caducidad",
    dataTips: "Fecha de caducidad no válida",
    cvv: "CVV",
    cvvTips: "Por favor, introduzca un CVV válido",
  },

  //国际卡确定订单页
  creditCard: {
    payingWith: "Pagando con",
    card: "Tarjeta",
    cvv: "CVV",
  },

  //买币确定订单页 - 巴西支付
  configPay_brl: {
    phoneNumber: "Número de teléfono móvil",
    fullName: "Nombre completo",
    formTitle: "Introduzca sus datos",
    code_tips:
      "Escanear el código QR a través de su PIX para completar el pago",
    name_tips: "¡Nombre inválido!",
    id_tips: "¡Identificación inválida!",
    number_tips: "¡Número de teléfono móvil no válido!",
    selectCountry: "Seleccionar país",
  },

  //确认订单页 - 墨西哥支付
  opmPayment: {
    banco: "Banco",
  },

  //弹出框文案
  components_payConfig: {
    title_THB: "Pago en curso",
    button_THB: "Comprobar el pedido",
    button_timeOut: "Volver a la página de inicio",
    button_timeOut1: "Volver al inicio",
    double: "Por favor, no haga un pago doble",
    completed: "Por favor, confirme que su transferencia ha sido completada",
    timeorder: "Este pedido está fuera de plazo",
    checkout: "¿Está seguro de dejar la caja?",
    buttonLeave: "Cerrar pedido",
  },

  //买币历史订单页+买币订单详情页
  buyHistory: {
    buyPrice: "Precio ",
    buyTotal: "Total ",
    buyOrderID: "ID del pedido",
    buyOrdeTime: "Hora del pedido",
    buyPaymentTime: "Hora de pago",
    buyPayerAccount: "Cuenta del pagador",
    buyCompleted: "Completado",
    buyFailed: "Fallido",
    buyClosed: "Cerrado",
    history_noListText: "No hay transacciones",
    history_noListButton: "Comprar NFT ahora",
    history_noMore: "No hay más",
  },

  //登陆页
  loginPage: {
    enterEmail: "¿Cuál es su dirección de correo electrónico?",
    enterEmail1: "¿Es este su dirección de correo electrónico?",
    emailanother: "Acceder con otra dirección de correo electrónico",
    emailNotyou: "¿No es usted?",
    codeTitle1: "Introduzca el código de acceso que acaba de recibir",
  },
  nav: {
    //买币确认订单文案提示
    buyConfigPaytitle: "Al continuar, usted acepta nuestra ",
    /**
     * 按钮文案
     */
    Continue: "Continuar",
    Confirm: "Confirmar",
    ConfirmPayment: "Confirmar el pago",
    queryOderState: "He completado el pago",
    Proceed: "Proceder",

    //风险账户文案
    accountTraded: "Esta cuenta está en riesgo y no se puede comerciar ahora.",

    /**
     * 路由
     */
    routerName_Transactions: "Historial de pedidos",
    routerName_paymentMethod: "Elegir forma de pago",
    routerName_creditCardConfig: "Confirmar pago",
    routerName_buyPayment: "Pago",
    routerName_buyOtherWayPay: "Confirmar el pago",
    routerName_paymentResult: "Resultado del pago",
    routerName_kycOnfido: "Prueba de ID & Selfie",
    routerName_kycSumsub: "Prueba de identificación y Selfie y POA",

    /**
     * 组件
     */
    networkAddress_components_title: "Dirección",

    /**
     * 登陆
     */
    login: "Iniciar sesión",
    login_required: "Error de formato",
    login_necessary: "necesario",

    loginTitle1: "Pago con Alchemy Pay",
    loginTitle2:
      "La forma más rápida y segura de pagar en cientos de aplicaciones criptográficas",

    codeTitle2: "¿No se ha recibido? ",
    codeTitle3: "Nuevo código de verificación enviado",
    codeSecond: "s",
    code_text: "He leído y estoy de acuerdo con Alchemy Pay",
    code_and: "y",
    code_name2: "Política de privacidad",

    /**
     * 首页
     */
    copyTips: "éxito con la copia",

    //买币 - 确认订单 - 国际卡
    buy_configPay_title1: "Pagando con",

    //买币 - 确认订单 - 印尼支付
    buy_configPayIDR_va_title: "BANCO",
    buy_configPayIDR_va_codeTitle: "Código de pago",
    buy_configPayIDR_codeTips: "Escanear el código QR para completar el pago",
    buy_configPayIDR_ovo_phoneTips:
      "Abrir la aplicación OVO para completar el pago",

    // 后增
    search_components_placeHolder: "Buscar aquí... ",
    buy_configPayIDR_ovo_title: "Teléfono móvil OVO",
    login_getCode: "Reenviar código",
    login_VerifyCode:
      "Por favor, introduzca el código de verificación de seis dígitos",
    login_Agreement: "Por favor, marque el Acuerdo de Usuario",
  },

  //确认订单通用
  confirmOrder: {
    pleasePay: "Por favor, pague",
  },

  //首页
  homePage: {
    purchaseNFT: "Comprar NFT",
    item: "Artículo",
    quantity: "Cantidad",
    youPay: "Usted paga",
    proceedBuy: "Proceder · Comprar",
    selectCurrency: "Seleccione la moneda",
    tiemErrToast:
      "Se agotó el tiempo de espera del pedido y no se puede realizar el siguiente paso",
    USDTips: "Actualmente no admite USD, elija otra moneda fiduciaria",
  },

  //交易历史
  transactionHistory: {
    buy: "Comprar",
    item: "Artículo",
    price: "Precio",
    quantity: "Cantidad",
    total: "Total",
    uniqueId: "Identificación única",
    loading: "Cargando",
    loadingFailed: "Carga fallida",
  },
  //等待组件
  buypayWait: {
    Processing: "Procesando",
    progress: "orden en progreso",
    purchase: "Pedido en curso para comprar este artículo ",
    transaction: "completar esta transacción final!",
  },
  //结果页
  payResult: {
    buttonText: "Volver a ",
    goHistory: "Ver el historial de pedidos",
    closed1: "Este pedido está fuera de plazo.",
    closed2: "Por favor, realice el pedido de nuevo",
    failed1: "¡Pago fallido!",
    failed2: "La información es incorrecta y ha sido rechazada por el banco.",
    failed1010:
      "El importe del pago no coincide con el límite del método de pago actual",
    success1: "¡Gracias!",
    success2: "La compra se ha realizado con éxito",
    success3:
      "Le hemos enviado un correo electrónico con los detalles del pedido",
    waitTips: "A la espera del pago",
  },

  //费用信息组件
  buyFee_components: {
    codeSecond: "s",
    title: "Compra de NFT para",
    rampFee: "Procesando Ramp",
    rampFeeTips: "tan bajo como",
    networkFee: "Cuota de red",
    tips: "Basado en la forma de pago",
  },

  // kyc_onfido
  kycAlert: {
    waiting_msg: "Su Prueba de ID Proof & Selfie está en revisión:",
    success_msg: "Verificación de identidad exitosa",
    failure_msg: "Volver a enviar los documentos relacionados",
  },
  kycStatus: {
    account: "Cuenta:",
    login_time: "Última hora de inicio de sesión:",
    verify_succeeded: {
      tips: "Verificación de identidad exitosa",
      content:
        "¡Enhorabuena! Todos los documentos presentados han pasado el proceso de verificación. Su límite de operaciones se ha incrementado a un monto equivalente a {0}",
      process: "Proceso",
    },
    verify_exception: {
      tips: "Volver a enviar los documentos relacionados",
      update_document: "Actualizar documentos",
    },
    verify_failed: {
      tips: "Verificación de identidad rechazada",
    },
    verify_waiting: {
      received_documents: "Hemos recibido sus documentos KYC",
      notify_you:
        "Le notificaremos una vez tengamos el resultado de la verificación a través de correo electrónico. Normalmente tardará entre 5 y 10 minutos. En casos excepcionales, se realizará una revisión manual. La revisión manual se completará en 24 horas",
      leave: "Salir ahora",
      under_review: "En revisión...",
      estimated_time: "Tiempo estimado de espera:",
      waiting_time: "Ha esperado por:",
      reviewed_now:
        "Los documentos que ha enviado están siendo revisados en este momento",
    },
  },
  //kyc验证页面
  kycVerificationFonts: {
    kycminutestitle:
      "Por favor, verifique su identidad. Suele tardar unos 2 minutos",
    kycPrepareyour: "Prepare su documento de identidad",
    kycminutosdocumento: "Prepárese para tomarse un selfie con el documento",
    kycButtonminutes: "Comenzar la verificación",
    kyccompleted1: "¡Felicitaciones! ",
    kyccompleted2: "Su verificación completada.",
    kycButtoncompleted: "Continuar el pago",
    kycPayLimitUpTips: "Límite de pago hasta",
    kycError: "Su verificación falló",
    kycRiskAccount: "La cuenta está en riesgo y no se puede comerciar ahora",
    kycButtonError: "Volver a la página de inicio",
    kycButtonTryAgain: "Inténtelo de nuevo",

    kyc2_startTitle: "Por favor, proporcione su material de dirección",
    kycErrorTips:
      "Por favor, asegúrese de que su dirección es auténtica y verificable",
    kycErrorTryAgain_title: "Su verificación ha fallado",
    kycErrorTryAgain_tipsTitle: "Por favor, asegúrese",
    kycErrorTryAgain_tips1: "Ha presentado su propio documento de identidad",
    kycErrorTryAgain_tips2:
      "El nombre de su documento de identidad es idéntico al nombre del titular de la tarjeta de pago",
    kycErrorTryAgain_tips3:
      "No ha utilizado varios documentos de identidad para la verificación KYC",
  },
};
